// extracted by mini-css-extract-plugin
export default {"card":"cardAuthStyle_card__g8pqW","header":"cardAuthStyle_header__In5mR","content":"cardAuthStyle_content__cOPe8","actions":"cardAuthStyle_actions__xASfv"};